export const subscriptionRoutes = [
  {
    path: '/subscription',
    children: [
      {
        path: 'settings',
        component: () => import(/* webpackChunkName: "subscription" */ '@/features/subscription/views/SubscriptionSettings.vue'),
      }
    ]
  }
]
